const startOfDay = (d) => {
  const r = new Date(d)
  r.setHours(0, 0, 0, 0)
  return r
}

const startOfWeek = (d) => {
  const r = startOfDay(d)
  const day = r.getDay() // 0=Sun..6=Sat
  const diffToMonday = day === 0 ? -6 : 1 - day
  r.setDate(r.getDate() + diffToMonday)
  return r
}

const startOfMonth = (d) => {
  const r = new Date(d)
  r.setDate(1)
  r.setHours(0, 0, 0, 0)
  return r
}

const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

// Returns { from, to } Date bounds for a quick-range label. "Last 30 min -
// Realtime" gets the same 30-minute window as "Last 30 min" — it's used to
// backfill the chart before the live socket connects, not just to gate the
// history API (see BmsDashboard: history seeds the buffer, socket appends).
export const computeQuickRangeBounds = (label, now = new Date()) => {
  const to = new Date(now)
  switch (label) {
    case 'Last 30 min - Realtime':
    case 'Last 30 min':
      return { from: new Date(now - 30 * MINUTE), to }
    case 'Last 1 hr':
      return { from: new Date(now - HOUR), to }
    case 'Last 3 hr':
      return { from: new Date(now - 3 * HOUR), to }
    case 'Last 12 hr':
      return { from: new Date(now - 12 * HOUR), to }
    case 'Last 1 day':
      return { from: new Date(now - DAY), to }
    case 'Last 7 days':
      return { from: new Date(now - 7 * DAY), to }
    case 'Last 30 days':
      return { from: new Date(now - 30 * DAY), to }
    case 'Today':
      return { from: startOfDay(now), to }
    case 'Yesterday': {
      const start = startOfDay(now)
      return { from: new Date(start.getTime() - DAY), to: start }
    }
    case 'This week':
      return { from: startOfWeek(now), to }
    case 'Previous week': {
      const start = startOfWeek(now)
      return { from: new Date(start.getTime() - 7 * DAY), to: start }
    }
    case 'This month':
      return { from: startOfMonth(now), to }
    case 'Previous month': {
      const start = startOfMonth(now)
      return { from: new Date(start.getFullYear(), start.getMonth() - 1, 1), to: start }
    }
    default:
      return { from: null, to: null }
  }
}

// Parses the "dd-mm-yyyy hh:mm" text the custom-range inputs collect.
export const parseCustomDateTime = (str) => {
  const match = str?.trim().match(/^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})$/)
  if (!match) return null
  const [, dd, mm, yyyy, hh, min] = match
  const parsed = new Date(Number(yyyy), Number(mm) - 1, Number(dd), Number(hh), Number(min))
  return Number.isNaN(parsed.getTime()) ? null : parsed
}
